import { usePlanningStore } from '@planning/AppProvider'
import { OrderHoldsSectionStore } from '@planning/components/hold/organisms/stores/OrderHoldsSectionStore'
import holdService from '@planning/services/holdService'
import { useTranslate } from '@tolgee/react'
import { useCallback, useRef, useState } from 'react'

export const useAddHoldDialog = () => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()
  const [open, setOpen] = useState(false)
  const holdsStoreRef = useRef<OrderHoldsSectionStore | null>(null)
  const containerJourneyIdRef = useRef<number | null>(null)

  const onAddHold = useCallback((containerJourneyId: number) => {
    containerJourneyIdRef.current = containerJourneyId
    holdsStoreRef.current = new OrderHoldsSectionStore({
      holds: [{ holdTypeId: null, description: '', customsEntries: [] }],
    })
    setOpen(true)
  }, [])

  const [isLoading, setIsLoading] = useState(false)

  const onClose = useCallback(() => {
    setIsLoading(false)
    setOpen(false)
  }, [])

  const onConfirm = useCallback(async () => {
    const store = holdsStoreRef.current
    const containerJourneyId = containerJourneyIdRef.current
    if (!store || !store.validate() || !containerJourneyId) return

    setIsLoading(true)
    try {
      await holdService.createBulk({
        containerJourneyId,
        holds: store.holds.value.map(h => ({
          holdTypeId: h.holdTypeId.value!,
          reason: h.description.value,
          contact: h.description.value,
        })),
      })
      appViewStore.setShowAlert('success', t('holdAddedSuccessfully', 'Hold added successfully'))
      setOpen(false)
    } catch {
      appViewStore.setShowAlert('error', t('failedToAddHold', 'Failed to add hold'))
    } finally {
      setIsLoading(false)
    }
  }, [appViewStore, t])

  return {
    onAddHold,
    dialogProps: {
      open,
      isLoading,
      store: holdsStoreRef.current,
      onClose,
      onConfirm,
    },
  }
}
